export default {
  technicalTitle: 'Erreur technique',
  unavailableTitle: 'Désolé',
  unauthorizedTitle: 'Accès restreint',
  technicalMessage: 'Une erreur technique est survenue. Nous sommes désolés des inconvénients que cela peut vous causer.',
  unavailableMessage: 'Le service est indisponible pour l\'instant. Nous sommes désolés des inconvénients que cela peut vous causer.',
  unauthorizedMessage: 'Désolé, vous n\'avez pas accès à cette page.',
  tryLater: ' Veuillez réessayer plus tard.',
  retryButton: 'Réessayer',
  unauthorizedButton: 'Aller à l\'accueil',
};
